<template>
  <div>
    <div class="botonera-enquestes">
      <b-button size="sm" id="enquestes-btn-nova" variant="primary" @click.prevent="onEditarEnquesta({})">
        <b-icon icon="plus" aria-hidden="true"></b-icon>
        {{ $t('btn.nova.enquesta') }}
      </b-button>
      <b-button-group size="sm" id="enquestes-btn-cercar">
        <b-button size="sm" v-b-toggle.collapse-filtre variant="outline-primary">
          <b-icon icon="filter" aria-hidden="true"></b-icon>
        </b-button>
        <b-button size="sm" variant="outline-primary" @click.prevent="listAgrupacions({})">
          <b-icon icon="search" aria-hidden="true"></b-icon>
          {{ $t('btn.cercar') }}
        </b-button>
      </b-button-group>
    </div>

    <b-collapse id="collapse-filtre" class="mt-2">
      <b-card class="filtre-enquestes mb-3">
        <b-row>
          <b-col lg="9" md="8" sm="12">
            <b-input-group id="input-group-datepicker" size="sm" prepend="Any activació: ">
              <DatePickerYear v-model="anyFiltre" :format="datePickerFormat" :language="ca" name="datepicker" minimum-view="year"
                              id="datepicker-year-input" @input="onSetMonthFiltre" placeholder="Seleccioni un any" style="z-index:1;" />
            </b-input-group>
          </b-col>
          <b-col lg="3" md="4" sm="12" class="filtre-btn-enquestes">
            <b-button size="sm" variant="outline-primary" @click.prevent="onResetFiltre()">
              <b-icon icon="trash" aria-hidden="true"></b-icon>
              Eliminar filtre
            </b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-collapse>

    <b-card>
      <b-tabs id="agrupacions-tab" ref="agrupacionsTab" v-model="tabIndex" class="mb-n4 pb-1">
        <b-tab v-for="(item,idx) in this.itemsAgrupacions" :key="'agrupacio-tab-' + idx" :title="item.nom" :title-link-class="linkClass(idx)" title-item-class="mb-0">
          <b-table id="enquestes-table" ref="enquestesTable" small :fields="fields" :items="item.enquestes" responsive="sm" class="mb-0">
            <template v-slot:cell()="data">
              <ItemEnquesta v-bind:initialValue="data.item"
                            v-on:editar-enquesta="onEditarEnquesta"
                            v-on:editar-quota="onEditarQuotaEnquesta"
                            v-on:eliminar-enquesta="onEliminarEnquesta"
                            v-on:eliminar-quota="onEliminarQuotaEnquesta"
                            v-on:eliminar-activacio="onEliminarActivacioEnquesta"
                            v-on:editar-activacio="onEditarActivacioEnquesta"
                            v-on:assignar-activacio="onAssignarActivacioEnquesta"
                            v-on:activar-activacio="onActivarActivacioEnquesta"
                            v-on:detalls-activacio="onDetallsActivacioEnquesta"
                            v-on:consultar-resultats="onConsultarResultats"
                            v-on:exportar-resultats="onExportarResultats"/>
            </template>
          </b-table>
        </b-tab>
      </b-tabs>
    </b-card>

    <ModalEdicioEnquesta id="modal-editar-enquesta" v-bind:enquesta="enquesta"
                         v-on:enquesta-editada="onEnquestaEditada"/>
    <ModalQuotaEnquesta id="modal-quota-enquesta" v-bind:quota="quota" v-on:quota-editada="onQuotaEnquestaEditada"/>
    <ModalActivacioEnquesta id="modal-activacio-enquesta" v-bind:activacio="activacio"
                            v-on:activacio-editada="onActivacioEnquestaEditada"/>
    <ModalAssignacioEnquesta id="modal-assignacio-enquesta" v-bind:activacio="activacio"
                             v-on:activacio-assignada="onActivacioEnquestaEditada"/>
  </div>
</template>

<script>
import ModalEdicioEnquesta from './ModalEdicioEnquesta.vue';
import ModalQuotaEnquesta from './ModalQuotaEnquesta.vue';
import ModalActivacioEnquesta from './ModalActivacioEnquesta.vue';
import ModalAssignacioEnquesta from './ModalAssignacioEnquesta.vue';
import enquestaService from "../../services/EnquestaService";
import ItemEnquesta from './ItemEnquesta.vue';
import router from '../../router'
// import { MonthPickerInput } from 'vue-month-picker'
import agrupacioEnquestesService from "@/services/AgrupacioEnquestesService"
import DatePickerYear from 'vuejs-datepicker'
import {ca} from 'vuejs-datepicker/dist/locale'
export default {
  name: "admin-enquestes",
  components: {
    ItemEnquesta,
    ModalEdicioEnquesta,
    ModalQuotaEnquesta,
    ModalActivacioEnquesta,
    ModalAssignacioEnquesta,

    // MonthPickerInput
    DatePickerYear
  },
  computed:{
    fields(){
      //Els fiquem a computed per les traduccions
      return [          
          { key: 'e', label: '',thClass:'th-enquestes-table',tdClass:'td-enquestes-table' }
        ];
    }
  }, 
  data() {
    return {
      tabIndex: 0,
      agrupacions: [],
      itemsAgrupacions: [],
      filtre:{},
      enquesta:{},
      activacio:{},
      quota:{},
      enquestes: [],
      months: ['gener','febrer','març','abril','maig','juny','juliol','agost','setembre','octubre','novembre','desembre'],

      anyFiltre: '',
      datePickerFormat: 'yyyy',
      ca: ca

    };
  },
  methods: {
    async listAgrupacions() {
      try{
        console.time("MyTimer");
        console.timeLog("MyTimer", "ANTES DEL LISTADO DE ENQUESTES");

        // const response = await enquestaService.listEnquestes(this.filtre);
        const response = await agrupacioEnquestesService.listAgrupacions(false);

        console.timeLog("MyTimer", "DESPUÉS DEL LISTADO DE ENQUESTES");
        console.timeEnd("MyTimer");

        this.agrupacions = response.data;
        this.initItemsAgrupacions();
      }catch(e){
        console.log(e);
      }      
    },
    initItemsAgrupacions(){
      let j;
      this.itemsAgrupacions = [];

      for(j = 0; j < this.agrupacions.length; j++) {
        let agrupacio = {};
        let enquestes = [];

        this.agrupacions[j].enquestes.forEach(e=>this.filtraEnquesta(e));
        enquestes = this.agrupacions[j].enquestes.filter(e=>!e.filtered);
        if(enquestes.length > 0){
          agrupacio = Object.assign({}, this.agrupacions[j]);
          agrupacio.enquestes = [].concat(enquestes);
          this.itemsAgrupacions.push(agrupacio);
        }
      }
      this.$root.$emit('filter-enquestes-activacions');
    },
    onEditarEnquesta(data) {   
      this.enquesta = data;      
      this.$nextTick(() => {
        this.$bvModal.show('modal-editar-enquesta')
      })                 
    },
    onEnquestaEditada(data) {
      if(!this.enquesta.idEnquesta){
        for(let i=0; i < this.itemsAgrupacions.length; i++){
          if(this.itemsAgrupacions[i].idAgrupacio === data.idAgrupacio){
            this.itemsAgrupacions[i].enquestes.unshift(data);
          }
        }
      }else{        
        let i;
        let j;
        //Itera per les agrupacions i les seves enquestes i guarda l'enquesta editada a la posició corresponent
        for(j = 0; j < this.itemsAgrupacions.length; j++) {
          for(i = 0; i < this.itemsAgrupacions[j].enquestes.length; i++) {
            if(this.itemsAgrupacions[j].enquestes[i].idEnquesta == data.idEnquesta){
              this.itemsAgrupacions[j].enquestes[i] = data;
            }
          }
        }

      }
      this.$root.$emit('bv::refresh::table', 'enquestes-table')       
    },
    onEliminarEnquesta(data) {    
      let idEnquestaEliminar = data.idEnquesta;    
      enquestaService.eliminarEnquesta(idEnquestaEliminar).then(response => {        
        if(response.status == 200){
          this.itemsAgrupacions.forEach(function (a){
            a.enquestes = a.enquestes.filter(item => item.idEnquesta !== idEnquestaEliminar)
            this.$root.$emit('bv::refresh::table', 'enquestes-table')
          })
        }
      }).catch(e => {
          console.log(e);
      });                
    }, 
    onEditarQuotaEnquesta(data) {      
      this.quota = data;  
      this.$nextTick(() => {
        this.$bvModal.show('modal-quota-enquesta')
      })                 
    },
    onQuotaEnquestaEditada(data) {
      let enq = this.itemsAgrupacions.forEach(a => a.enquestes.forEach(e => e.idEnquesta == data.idEnquesta));
                              
      if(!this.quota.idQuota){
        enq.quotes.unshift(data);
      }else{ 
        let i = 0;
        let idx = 0;
        for(i = 0; i < enq.quotes.length; i++) {
          if(enq.quotes[i].idQuota == data.idQuota){
            idx = i;
          }
        }
        enq.quotes = enq.quotes.filter(quota => quota.idQuota !== data.idQuota)
        enq.quotes.splice(idx,0,data);
      }

      this.$root.$emit('bv::refresh::table', 'enquestes-table')
    },    
    onEliminarQuotaEnquesta(data) {    
      let idEnquestaEliminar = data.idEnquesta;
      let idQuotaEliminar = data.idQuota;
      enquestaService.eliminarQuotaEnquesta(idEnquestaEliminar,idQuotaEliminar).then(response => {                
        if(response.status == 200){
          let enq = this.itemsAgrupacions.forEach(a => a.enquestes.find(e => e.idEnquesta == idEnquestaEliminar));
          enq.quotes = enq.quotes.filter(quota => quota.idQuota !== idQuotaEliminar)
          this.$root.$emit('bv::refresh::table', 'enquestes-table') 
        }       
      }).catch(e => {
          console.log(e);
      });                
    },
    onEditarActivacioEnquesta(data){       
      this.activacio = data;
      this.$nextTick(() => {
        this.$bvModal.show('modal-activacio-enquesta');      
      })        
    },   
    onActivacioEnquestaEditada(data) {
      let enq;

      for(let i=0; i<this.itemsAgrupacions.length; i++){
        for(let j=0; j<this.itemsAgrupacions[i].enquestes.length; j++){
          if(this.itemsAgrupacions[i].enquestes[j].idEnquesta == data.idEnquesta){
            enq = this.itemsAgrupacions[i].enquestes[j];
          }
        }
      }

      if(!this.activacio.idActivacio){
        enq.activacions.unshift(data);
      }else{ 
        let i = 0;
        let idx = 0;
        for(i = 0; i < enq.activacions.length; i++) {
          if(enq.activacions[i].idActivacio == data.idActivacio){
            idx = i;
          }
        }
        enq.activacions = enq.activacions.filter(activacio => activacio.idActivacio !== data.idActivacio)
        enq.activacions.splice(idx,0,data);
      }

      // this.initItemsAgrupacions();
      this.$root.$emit('bv::refresh::table', 'enquestes-table')
    }, 
    onEliminarActivacioEnquesta(data) {    
      let idEnquestaEliminar = data.idEnquesta;
      let idActivacioEliminar = data.idActivacio;
      enquestaService.eliminarActivacioEnquesta(data).then(response => {                
        if(response.status == 200){
          let enq = this.itemsAgrupacions.forEach(a => a.enquestes.find(item => item.idEnquesta == idEnquestaEliminar));
          enq.activacions = enq.activacions.filter(activacio => activacio.idActivacio !== idActivacioEliminar)
          this.$root.$emit('bv::refresh::table', 'enquestes-table') 
        }       
      }).catch(e => {
          console.log(e);
      });                
    }, 
    onAssignarActivacioEnquesta(data){
      this.activacio = data;
      this.$nextTick(() => {
        this.$bvModal.show('modal-assignacio-enquesta');  
      })
    },
    onActivarActivacioEnquesta(data){
      enquestaService.activarEnquesta(data).then(response => {
        // this.listEnquestes();
        this.listAgrupacions();
        this.onActivacioEnquestaEditada(response.data);
      }
    )
        .catch(e => {
          console.log(e);
        });
    },    
    onDetallsActivacioEnquesta(data){
      console.log("data.idActivacio", data.idActivacio);
      let idEnquesta = data.idEnquesta;
      let idActivacio = data.idActivacio;
      enquestaService.getActivacioEnquesta(idEnquesta,idActivacio).then(response => {
        if(response.status == 200){
          let enq = this.itemsAgrupacions.forEach(a => a.enquestes.find(item => item.idEnquesta == idEnquesta));
          console.log(enq);
          let act = enq.activacions.find(act => act.idActivacio == idActivacio);
          act.quotes = response.data.quotes;
        }
      }).catch(e => {
          console.log(e);
      });
    },
    onResultatsAgregats(){
      let cerca = {};
      cerca.config = { 
          onlyTheFirstSubmitsByQuota: false,
          submitsByQuota: true,
          disaggregatedQuestions: [6,7],
        };
      cerca.filtres = [];
      this.itemsAgrupacions.forEach(a => a.enquestes.filter(e=>!e.filtered).forEach(function(e){
        var filtreEnquesta = {};
        filtreEnquesta.idEnquesta = e.idEnquesta;
        filtreEnquesta.activacions = [];
        if (e.activacions.filter(a=>a.filtered).length > 0){
          e.activacions.filter(a=>!a.filtered).forEach(function(a){
            var filtreActivacio = {};
            filtreActivacio.idActivacio = a.idActivacio;
            filtreEnquesta.activacions.push(filtreActivacio);
          });
        }
        cerca.filtres.push(filtreEnquesta);
      }));

      this.onConsultarResultats(cerca);
    },
    onConsultarResultats(data){      
      let cerca = data;
      if(!cerca.config){
        cerca.config = {};
      }
      //cerca.config.onlyTheFirstSubmitsByQuota=false;
      //cerca.config.submitsByQuota=true;
      //cerca.config.ignoredOptionsDonutsChart = ['9'];
      
      router.push({ name: 'resultats', params: cerca });
    },
    async onExportarResultats(data){
      try{
        const response = await enquestaService.exportResultats(data);
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'export-resultats.xls');
        document.body.appendChild(link);
        link.click();
      }catch(e){
        console.log(e);
      }
    },
    veureDetalls(data){
      if(!data.detailsShowing){            
          enquestaService.getEnquesta(data.item.idEnquesta).then(response => {
            data.item.questionari = response.data.questionari;       
            data.item.quotes = response.data.quotes;       
            data.toggleDetails();
          }).catch(e => {
            console.log(e);
          });                                  
      }else{data.toggleDetails();}      
      
    },
    onResetFiltre(){
      this.anyFiltre = '';
      this.filtre = {};
       this.initItemsAgrupacions();
    },
    onSetMonthFiltre(){
      // this.filtre.mesActivacio = evt.monthIndex>9?''+evt.monthIndex:'0'+evt.monthIndex;
      this.filtre.anyActivacio = this.anyFiltre.getFullYear();
      this.initItemsAgrupacions();
    },
    filtraEnquesta(e){
      // console.log("filtraEnquesta - valor de e: " );
      // console.log(e);
      e.lastFilteredDate=new Date().getTime();
      e.activacions.forEach(a=>this.filtraActivacio(a));
      e.filtered = e.activacions.filter(a=>!a.filtered).length==0;

    },
    filtraActivacio(a){

      a.filtered = false;
      var mesiany;
      var any;

      if(this.filtre.anyActivacio){
        if(a.dataActivacio==null && a.dataCreacio==null) {
          a.filtered = true;
          return;
        }

        if(a.dataActivacio!=null){
          mesiany = a.dataActivacio.split(' ')[0].split('-');
        }else{
          mesiany = a.dataCreacio.split(' ')[0].split('-');
        }

        any = mesiany[2];
        a.filtered = any!=this.filtre.anyActivacio;

      }

    },
    linkClass(idx) {
      if (this.tabIndex === idx) {
        return ['bg-primary', 'text-light']
      } else {
        return ['bg-light', 'text-info']
      }
    }
  },
  mounted() {},
  created () {
    // fetch the data when the view is created and the data is
    // already being observed
    this.listAgrupacions();
    console.log("CREADO")
  }
};
</script>

<style>
.botonera-enquestes {
  text-align: right;
  margin-top: 10px;  
  margin-bottom: 10px
}
.filtre-btn-enquestes {
  text-align: right;
}
#enquestes-btn-cercar{
  margin-right: 5px;
}
#enquestes-btn-nova{
  margin-right: 5px;
}
#enquestes-table{    
  text-align: left;
  color: #858796;
  border: 0 solid #e3e6f0;  
}
.th-enquestes-table{
  vertical-align: middle !important;
  padding: .45rem !important;
}
.td-enquestes-table{
  vertical-align: middle !important;
  padding: 0 !important;
}
.td-progress-bar{
  min-width: 80px;  
}
.item-quota{
  width: 100%;  
}
.month-picker__container{
  background-color: white;
}
.month-picker-input{
  height: calc(1.5em + 0.5rem + 2px);
    padding: 0.25rem 0.5rem;
    font-size: 0.875rem;
    line-height: 1.5;
    border-radius: 0.2rem;
}
</style>